// extracted by mini-css-extract-plugin
export default {"stocks":"style_stocks__nVtKi"};